<template>
  <!-- 移除 v-if，改用动态样式控制显示，确保过渡动画生效 -->
  <div 
    id="toast-modal"
    style="z-index: 9999;"
    class="fixed inset-0 z-102 flex items-center justify-center transition-opacity duration-300"
    :class="{ 
      'opacity-0 pointer-events-none': !isShow,  // 隐藏状态：透明+不可点击
      'opacity-100': isShow                     // 显示状态：不透明
    }"
  >
    <!-- 背景遮罩：加深透明度到90%，并添加过渡动画 -->
    <div 
      class="absolute inset-0 backdrop-blur-sm transition-opacity duration-300"
      :class="isShow ? 'bg-dark/90' : 'bg-dark/0'"
      id="toast-backdrop"
    ></div>
    
    <!-- 弹窗内容：动态缩放动画 -->
    <div
      class="relative bg-dark-800 rounded-2xl w-full max-w-md mx-4 overflow-hidden gradient-border transform transition-transform duration-300"
      :class="{ 
        'scale-95 opacity-0': !isShow,  // 隐藏状态：缩小+透明
        'scale-100 opacity-100': isShow // 显示状态：正常大小+不透明
      }"
      id="toast-content"
    >
      <!-- 内容部分保持不变 -->
      <div class="p-6 md:p-8 text-center">
        <div v-html="innerHTML" id="toast-icon" class="w-16 h-16 mx-auto mb-4 rounded-full flex items-center justify-center"></div>
        <h3 class="text-xl font-bold mb-2" id="toast-title">{{title}}</h3>
        <p class="text-dark-600 mb-6" id="toast-message">{{message}}</p>
        <button 
          id="toast-confirm"
          @click="isShow=false"
          class="w-full py-3 px-4 bg-gradient-to-r from-primary to-accent rounded-lg font-medium hover:opacity-90 transition-all duration-300"
        >
          确定
        </button>
      </div>
    </div>
  </div>
</template>
<script>
import Vue from 'vue'
export default {
  data(){
    return {
      isShow: false,
      title: '',
      message:'',
      innerHTML:''
    }
  },
  mounted() {
    this.$bus.$on('showtoast', (options) => {
    const { title, message, type = 'success' } = options;
    // 填充弹框内容（复用原逻辑）
    this.title = title;
    this.message = message;
   // 图标样式修复（确保FontAwesome可用）
      const iconMap = {
        success: { class: 'fa-check text-green-500', bg: 'bg-green-500/20' },
        error: { class: 'fa-exclamation-circle text-red-500', bg: 'bg-red-500/20' },
        info: { class: 'fa-info-circle text-primary', bg: 'bg-primary/20' }
      };
      const icon = iconMap[type] || iconMap.info;
      this.innerHTML = `<i class="fa ${icon.class} text-2xl"></i>`;
      // 给图标容器添加背景色
      this.$nextTick(() => {
        const iconEl = document.querySelector('.w-16');
        if (iconEl) iconEl.className += ' ' + icon.bg;
      });
    console.log(options)
    this.isShow=true
  });
  },
  beforeDestroy() {
    // 移除事件监听，防止内存泄漏
    Vue.prototype.$bus.$off('showtoast');
  }
}
</script>